export type StatusTone =
  | "success"
  | "warning"
  | "error"
  | "info"
  | "neutral"
  | "violet"
  | "slate"
  | "dark";

// slate, info, success y dark existen para empatar con la leyenda del grafico de
// Finance (SalesCycleChart STATUS_SEGMENTS): un mismo estado no puede tener dos
// colores en el producto. slate=#94a3b8, info=#3b82f6, success=#10b981,
// dark=#1f2937.
const DOT_TONES: Record<StatusTone, string> = {
  success: "bg-emerald-500",
  warning: "bg-amber-400",
  error: "bg-red-500",
  info: "bg-blue-500",
  neutral: "bg-gray-300",
  violet: "bg-violet-500",
  slate: "bg-slate-400",
  dark: "bg-gray-800",
};

const CHIP_TONES: Record<StatusTone, string> = {
  success: "bg-emerald-50 text-emerald-700",
  warning: "bg-amber-50 text-amber-700",
  error: "bg-red-50 text-red-700",
  info: "bg-blue-50 text-blue-700",
  neutral: "bg-gray-100 text-gray-600",
  violet: "bg-violet-50 text-violet-700",
  slate: "bg-slate-100 text-slate-700",
  dark: "bg-gray-200 text-gray-900",
};

export const StatusDot = ({
  tone,
  label,
  className = "",
}: {
  tone: StatusTone;
  label: string;
  className?: string;
}) => (
  <span className={`inline-flex min-w-0 items-center gap-1.5 text-xs font-medium text-gray-600 ${className}`}>
    <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${DOT_TONES[tone]}`} />
    <span className="min-w-0 truncate">{label}</span>
  </span>
);

export const StatusChip = ({ tone, label }: { tone: StatusTone; label: string }) => (
  <span
    className={`inline-flex h-6 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-xs font-semibold ${CHIP_TONES[tone]}`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${DOT_TONES[tone]}`} />
    {label}
  </span>
);
